// Centralized Stripe product & price IDs
export const STRIPE_PLANS = {
  starter: {
    productId: "prod_TznG3obByG3AKm",
    priceId: "price_1T4sc6BXMoK8kr1zMcx79kBU",
    name: "Starter",
    price: 9,
    label: "Starter (9€/mois)",
  },
  pro: {
    productId: "prod_TznHdI6gyD5GJc",
    priceId: "price_1T4scDBXMoK8kr1zEI6Ex9Pm",
    name: "Pro",
    price: 29,
    label: "Pro (29€/mois)",
  },
} as const;

export const PRO_PRODUCT_ID = STRIPE_PLANS.pro.productId;
export const STARTER_PRODUCT_ID = STRIPE_PLANS.starter.productId;

export const PLAN_MAP: Record<string, { name: string }> = {
  [STARTER_PRODUCT_ID]: { name: "Starter" },
  [PRO_PRODUCT_ID]: { name: "Pro" },
};
